import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import Home from './components/Home/Home'
import Nav from './components/Nav/Nav'
import Footer from './components/Shared/Footer'

const queryClient = new QueryClient()

function App() {
    useEffect(() => {
        AOS.init()
    }, [])

    return (
        <>
            <Nav />
            <QueryClientProvider client={queryClient}>
                <Home />
            </QueryClientProvider>
            <Footer />
        </>
    )
}

export default App
